import * as Sentry from '@sentry/browser';
import { ILogger } from '../../Contracts';
import { version } from '../../../package.json';
/**
 * Initialize Sentry with the provided configuration
 * @param options Configuration options for Sentry
 */
export const initSentry = (options?: {
  dsn?: string;
  environment?: string;
  release?: string;
  debug?: boolean;
  tracesSampleRate?: number;
}) => {
  const {
    dsn = import.meta.env.VITE_SENTRY_DSN,
    environment = import.meta.env.VITE_ENVIRONMENT || 'development',
    release = version,
    debug = import.meta.env.DEV,
    tracesSampleRate = 1.0,
  } = options || {};

  // Only initialize if DSN is provided
  if (!dsn && !import.meta.env.DEV) {
    throw new Error('Failed to initialise sentry. Missing dsn');
  }

  Sentry.init({
    dsn,
    environment,
    release,
    debug,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate,
  });
};

/**
 * Log an error to Sentry
 * @param error The error to log
 * @param context Additional context information
 */
export const logError = (error: Error) => {
  // Always log to console in development
  if (import.meta.env.DEV) {
    console.error(error);
  }
  // Log to Sentry
  return Sentry.captureException(error);
};
initSentry();
export const SentryService: ILogger = {
  logError,
};
